//Set data for session storage
export function setItemToStorage(keyname, value) {
  return localStorage.setItem(keyname, value);
}

//Get data for session storage
export function getItemFromStorage(keyname) {
  return localStorage.getItem(keyname);
}

//Remove specific data for session storage
export function removeItemFromStorage(keyname) {
  return localStorage.removeItem(keyname);
}

//Clear all data for session storage
export function clearStorage() {
  return localStorage.clear();
}
